const PUBLIC_KEY = process.env.VUE_APP_STRIPE_PUBLIC_KEY;

export function getPublicKey() {
  return PUBLIC_KEY;
}
